export const submissionStates = {
  default: 0,
  canSubmit: 1,
  startSubmit: 2,
  submitting: 3,
  submitError: 4,
  submitSuccess: 5
};